import * as yup from 'yup'
import { TYPE_REQUIRED } from 'constants/errors'
import loginFormSchema from 'schemas/loginFormSchema'

export default yup.object().shape({
  code: yup.string().required(TYPE_REQUIRED),
  remember: yup.boolean(),
}).concat(loginFormSchema as yup.ObjectSchema<any>)
